import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Switch from "@material-ui/core/Switch";
import { Grid } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";

const styles = (theme) => ({
  text: {
    fontFamily: "Roboto, sans-serif",
    fontSize: "1.1rem",
  },
  root: {
    height: "100%",
    backgroundColor: "#F5F5F5",
  },
  card: {
    backgroundColor: "#fff",
    position: "relative",
    top: "15px",
  },
});
/**
 * Card onde tem o switch de seleção, utilizado para selecionar algo
 */
class CardSwitch extends React.Component {
  /**
   * @param {boolean} props.disabled Boleano que definirá se o card estará desabilitado ou não
   * @param {boolean} props.checked Boleano que definirá se o switch foi selecionado
   */
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let { classes } = this.props;
    return (
      <Grid container direction="column" className={classes.card}>
        <Grid
          item
          container
          alignItems="center"
          justify="space-between"
          style={{ padding: "15px" }}
        >
          <Grid item xs={10}>
            <Typography className={classes.text}>{this.props.title}</Typography>
            {this.props.helperText && (
              <Typography variant="body2" color="textSecondary">
                {this.props.helperText}
              </Typography>
            )}
          </Grid>
          <Grid item xs={2}>
            <Switch
              disabled={this.props.disabled}
              checked={this.props.checked}
              onChange={this.props.func}
              color="primary"
            />
          </Grid>
        </Grid>
        <Divider />
      </Grid>
    );
  }
}
export default withStyles(styles)(CardSwitch);
